module.exports = __webpack_public_path__ + "tray.jpg?205c6cf80f6cc683c6414214fecb94f4";